// common flight string

export const FLIGHT_CONFIRM_VALUE = "SUCCESS";
export const FLIGHT_FAILURE_VALUE = "failed";
export const FLIGHT_PHONE_NUMBER = "+91-1204814491";
export const FLIGHT_OTP_LENGTH = 6;
export const CURRENCY = "₹";
export const FLIGHT_UTM_SOURCE = "B2B_SOUCRE";